import React from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { CreateDebtorForm } from '@/components/forms/CreateDebtorForm';


export const CreateDebtorsPage = () => {
    return (
        <AuthenticatedPageLayout>
            <CreateDebtorForm />
        </AuthenticatedPageLayout>
    );
};